import { utmTrackingKeys } from '../../utils/utmTracking'

/**
 * When a utm tracking code is present the trailer/feature page was access
 * from an external source. In this case using the browser "back" will not
 * go to the film details page, this must be catered for explicitly.
 *
 * This only applies if this is the very first page accessed and the utm
 * codes are still on the URL, they should not be taken from previously
 * cached values.
 *
 * @param {String} filmSlug
 * @param {Object} history React Router history
 * @param {Object} location React Router location
 * @returns {Function}
 */
export const onFilmPlayerClose = (filmSlug, history, location) => {
  const query = new URLSearchParams(location.search)
  return utmTrackingKeys(query).length ? () => history.replace(`/film/${filmSlug}`) : history.goBack
}
